import { appStorage } from './utilities/AppStorage';
import Device from './utilities/Device';
import { defaultErrorReporter } from './defaults/DefaultErrorReporter';
import { defaultI18n } from './defaults/DefaultI18n';
import { defaultSettings } from './defaults/DefaultSettings';
import { defaultAppStore } from './defaults/DefaultAppStore';
import { defaultModelsStore } from './defaults/DefaultModelsStore';
import { defaultCardTerminal } from './defaults/DefaultCardTerminal';
class DIContainer {
    dependencies = new Map();
    defaults = new Map();
    constructor() {
        this.defaults.set('appStorage', appStorage);
        this.defaults.set('device', Device);
        this.defaults.set('errorReporter', defaultErrorReporter);
        this.defaults.set('i18n', defaultI18n);
        this.defaults.set('settings', defaultSettings);
        this.defaults.set('store', defaultAppStore);
        this.defaults.set('modelsStore', defaultModelsStore);
        this.defaults.set('cardTerminal', defaultCardTerminal);
        this.defaults.set('htmlGen', null); // Framework-specific, apps must provide
        this.defaults.set('orderRenderComponent', null); // Framework-specific, apps must provide
    }
    register(name, dependency) {
        if (this.dependencies.has(name)) {
            throw new Error(`Dependency ${name} is already registered.`);
        }
        this.dependencies.set(name, dependency);
    }
    resolve(name) {
        const dependency = this.dependencies.get(name) || this.defaults.get(name);
        if (!dependency) {
            throw new Error(`Unresolved dependency ${name}.`);
        }
        return dependency;
    }
}
export const diContainer = new DIContainer();
//# sourceMappingURL=DIContainer.js.map